export default {
    key: null,
    life_dt: null,
    name: null,
    link_page: null,
    photo: null,

    fillWithFromPage(page) {
        this.name = page.name;
        this.link_page = page.link;

        this.photo = page.main_image
            ? page.main_image
            : null;

        this.life_dt = page.start.year && page.end.year
            ? page.start.year + ' - ' +  page.end.year
            : '';
    }
}